export enum SharedQuestionState {
  LINKED = "LINKED",
  UNLINKED = "UNLINKED",
}
